// extracted by mini-css-extract-plugin
module.exports = {"letters":"style_letters__2fosV","letter":"style_letter__2wLO2","inView":"style_inView__3_WOr","single":"style_single__1HyhQ"};